import React, { useState, useEffect } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  LanguageFeature
} from "@dndModels";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";
import StringBox from "@components/input/strings/StringBox";

interface Props {
  obj: LanguageFeature;
  onChange: (changed: LanguageFeature) => void; 
  change_time: number;
  disabled: boolean;
}

export default function LanguageInput({ 
  obj,
  onChange,
  change_time,
  disabled = false 
}: Props) {
  const [my_obj, setObj] = useState(obj);
  const [prev_change_time, setChangeTime] = useState(change_time);
  const [reloading, setReloading] = useState(false);

  useEffect(() => {
    if (change_time !== prev_change_time) {
      setObj(obj);
      setChangeTime(change_time);
      // setReloading(true);
    }
  }, [change_time, prev_change_time, obj]);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  if (reloading) {
    return <></>;
  } else {
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 12
          }}>
          <StringBox 
            name="Count"
            value={my_obj.count}
            type="number"
            disabled={disabled}
            onBlur={(value: string) => {
              const new_obj = my_obj;
              new_obj.count = +value;
              onChange(new_obj);
              setObj(new_obj);
            }}
          /> 
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <SelectStringBox 
            name="Type"
            options={["Standard","Common","Exotic","Specific"]}
            value={my_obj.type}
            disabled={disabled}
            onChange={(value: "Standard" | "Common" | "Exotic" | "Specific") => {
              const new_obj = my_obj;
              new_obj.type = value;
              onChange(new_obj);
              setObj(new_obj);
            }}
          /> 
        </Grid>
        { my_obj.type === "Specific" && 
          <Grid
            size={{
              xs: 12
            }}>
            <SelectObjectBox
              name="Languages" 
              data_type="language"
              values={ my_obj.language_ids } 
              multiple
              // log_it
              disabled={disabled}
              onChange={(changed: string[]) => {
                const new_obj = my_obj;
                new_obj.language_ids = changed;
                onChange(new_obj);
                setObj(new_obj);
              }} 
            />
          </Grid>
        }
      </Grid>
    );
  }
}
